var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageNewsIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22372",
    "data-name": "Group 22372",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.153,
    height: 67,
    viewBox: "0 0 65.153 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2940",
    "data-name": "Rectangle 2940",
    width: 65.153,
    height: 67,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22371",
    "data-name": "Group 22371",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22179",
    "data-name": "Path 22179",
    d: "M56.208,30.637h0v-16.9A7.353,7.353,0,0,0,48.9,6.406h-.91V5.26a5.188,5.188,0,1,0-10.377,0V6.406H18.592V5.26a5.26,5.26,0,1,0-10.521,0V6.406H7.285A7.335,7.335,0,0,0,0,13.739v38.8a7.337,7.337,0,0,0,7.285,7.335H30.142A19.8,19.8,0,1,0,56.208,30.637M40.5,5.26a2.273,2.273,0,0,1,2.233-2.313h.061a2.3,2.3,0,0,1,2.319,2.27q0,.022,0,.043v5.613H40.5Zm-29.545,0a2.339,2.339,0,0,1,2.363-2.314h.007A2.352,2.352,0,0,1,15.709,5.26v5.613H10.953ZM2.882,13.739a4.45,4.45,0,0,1,4.4-4.451h.786v3.087a1.408,1.408,0,0,0,1.461,1.381h7.584a1.422,1.422,0,0,0,1.477-1.381V9.288H37.616v3.087a1.343,1.343,0,0,0,1.3,1.381h7.663a1.364,1.364,0,0,0,1.409-1.318c0-.021,0-.042,0-.063V9.288h.91a4.468,4.468,0,0,1,4.423,4.451v4.629H2.882V13.739m4.4,43.254a4.451,4.451,0,0,1-4.4-4.453V21.251H53.325V29.07a19.818,19.818,0,0,0-25.18,27.923Zm38.071,7.1a16.9,16.9,0,1,1,16.9-16.9h0a16.923,16.923,0,0,1-16.9,16.9",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22180",
    "data-name": "Path 22180",
    d: "M307.2,267.391h-6.314v-8.672a1.441,1.441,0,1,0-2.882,0v10.112a1.466,1.466,0,0,0,1.468,1.443H307.2a1.441,1.441,0,0,0,0-2.882",
    transform: "translate(-255.052 -220.199)",
    fill: "#004b23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageNewsIconImage);
export default __webpack_public_path__ + "static/media/home-page_news-icon-image.37f7f3b838a7366cb48b973bd1df4e31.svg";
export { ForwardRef as ReactComponent };